<template>
  <component
    :is="curComponent"
    :data="data"
  />
</template>

<script>
import _$ from 'js/api/getdata'
import bsLfolder from 'components/business/approve/lfolder/index.vue'
// 文件夹外链的展示页面
export default {
  components: {
    bsLfolder,
  },
  data() {
    return {
      curComponent: '',
      data: {},
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const {
        type,
        fromType, // 0 个人摆渡空间 1 管理控制台
        serialNumber,
        account_id,
        uid,
      } = this.$route.query
      // 跳转页面带过来的参数
      const params = {
        url: `/${type}/${serialNumber}`,
        account_id,
        uid,
        type,
        serial_number: serialNumber,
      }
      _$.getData('ferryInit', params).then((res) => {
        this.data = {
          fromType,
          ...res.data.data,
        }
        if (this.data.sender === null) {
          this.data.sender = {}
          this.data.sender.username = ''
        } // 处理sender为null的情况
        sessionStorage.setItem('rootName', this.data.sender.username)
        // 判断 右键权限
        if (fromType === '0') {
          if (this.data.type === 0) {
            sessionStorage.setItem('auth', 'preview')
          }
          if (this.data.type === 1) {
            if (this.data.sendNamespace === 0) {
              sessionStorage.setItem('auth', 'list')
            }
            if (this.data.sendNamespace === 1) {
              sessionStorage.setItem('auth', 'preview')
            }
          }
        } else if (fromType === '1') { // 管理控制台进全是可见列表
          sessionStorage.setItem('auth', 'list')
        }
        if (type === '0' && this.data.type === 0) {
          sessionStorage.setItem('character', 'outer')
        }
        // 接收空间验证
        if (type === '1' && this.data.type === 1) {
          sessionStorage.setItem('character', 'receive')
        }
        this.curComponent = 'bsLfolder'
      }).catch((error) => {
        if (error.response.status === 403) {
          this.data = {
            ...error.response.data,
          }
          this.curComponent = 'bsLfolder'
        }
      })
    },
  },
}
</script>
<style scoped>
</style>
